let host, frontendUrl;

if (window.location.hostname.indexOf("hrrpnepal.org") >= 0) {
  // host = "http://demo-bg.hrrpnepal.org";
  host = "https://backend.hrrpnepal.org";
  frontendUrl = "https://hrrpnepal.org"
}else if(window.location.hostname.indexOf("hrrpssl.yarsha.net") >= 0){
  host = "https://hrrpsslb.yarsha.net";
  frontendUrl = "https://hrrpssl.yarsha.net";
} else if (window.location.hostname.indexOf("yarsha.net") >= 0) {
  host = "http://hrrp.yarsha.net";
  frontendUrl = "http://hrrp-demo.yarsha.net";
} else {
  host = "http://hrrp.yarsha.net";
  // frontendUrl = "http://hrrp-demo.demosapp.net";
  frontendUrl = "http://localhost:3000";
}

export { host, frontendUrl };